import React, {Component} from 'react'
import {ReactComponent as PersonIcon} from '@shop/icon-fonts/optimized/person.svg'
import SearchBar from '../SearchBar'
import CartButton from '../CartButton'
import {AccountFlyout} from '../Account'
import AppContext from '../../context'
import {AccessibleText} from '../../utils/styled'
import {PrimaryIcon} from '../Icon/Icon.styled'
import {DEVICE_TYPES} from '../../utils'
import BurgerButton from './BurgerButton'
import * as SC from './MiddleBar.styled'
import {SECURITY_ICONS_ID} from '../../utils/constants';
import ExternalComponent from '../Injected'

export const LOGO_ID = 'srh-logo'
export const ACCOUNT_MIDDLE_BAR_BUTTON_ID = 'srh-account-mbbutton'
export const BURGER_MIDDLE_BAR_BUTTON_ID = 'srh-burger-mbbutton'

class MiddleBar extends Component {
  static contextType = AppContext

  constructor(props) {
    super(props);
    this.state = {
      showFlyout: false
    }

    this.accountFlyout = React.createRef()

    // Must be kept in as fn() because these function are
    // being spied using the class prototype in some tests
    this.onClickOutsideAccountFlyout = this.onClickOutsideAccountFlyout.bind(this)
    this.onClickBurgerNavButton = this.onClickBurgerNavButton.bind(this)
    this.flyoutOnClickHandler = this.flyoutOnClickHandler.bind(this)
  }

  onClickOutsideAccountFlyout(event) {
    if (this.accountFlyout.current && !this.accountFlyout.current.contains(event.target)) {
      this.setState({showFlyout: false})
      document.removeEventListener('click', this.onClickOutsideAccountFlyout)
    }
  }

  onClickBurgerNavButton() {
    const {toggleBurgerNav, isSearchFlyoutOpen, setSearchFlyoutOpen} = this.context
    toggleBurgerNav()
    if (isSearchFlyoutOpen) {
      setSearchFlyoutOpen(false)
    }
  }

  flyoutOnClickHandler() {
    const {showFlyout} = this.state
    const {isBurgerNavOpen, setBurgerNavOpen, isSearchFlyoutOpen, setSearchFlyoutOpen} = this.context
    if (isBurgerNavOpen) {
      setBurgerNavOpen(false)
    }
    if (isSearchFlyoutOpen) {
      setSearchFlyoutOpen(false)
    }
    if (!showFlyout) {
      document.addEventListener('click', this.onClickOutsideAccountFlyout)
    }
    this.setState({showFlyout: !showFlyout})
  }

  render() {
    const {showFlyout} = this.state
    const {device, translations, mediaServerUrl, showCart, viaWebC, securityIconsURL} = this.context
    const {showSearch, bundle, brand, showCategories, isBurgerNavOpen} = this.context
    const isMobile = device === DEVICE_TYPES.SMARTPHONE || device === DEVICE_TYPES.PHABLET

    return (
      <SC.MiddleBarStyled>
        {isMobile && showCategories
          && <BurgerButton
            id={BURGER_MIDDLE_BAR_BUTTON_ID}
            onClick={this.onClickBurgerNavButton}
            label={translations.get('shop.header.accessible.catalog.menu')}
            isActive={isBurgerNavOpen}
          />}

        <SC.LogoWrapper href="/">
          <SC.Logo
            id={LOGO_ID}
            src={`${mediaServerUrl}/images/${bundle}/logo/${brand}.png`}
            srcSet={`${mediaServerUrl}/images/${bundle}/logo/${brand}.png 1x, ${mediaServerUrl}/images/${bundle}/logo/${brand}@2x.png 2x`}
            alt={translations.get('shop.header.accessible.logo.alternative')}
          />
        </SC.LogoWrapper>

        {showSearch
          && <SearchBar />}

        {isMobile
          && <>
            <SC.MiddleBarButton
              id={ACCOUNT_MIDDLE_BAR_BUTTON_ID}
              onClick={this.flyoutOnClickHandler}
              aria-haspopup="true"
              aria-expanded={showFlyout}
            >
              <AccessibleText>
                {translations.get('shop.header.accessible.account.menu')}
              </AccessibleText>
              <PrimaryIcon>
                <PersonIcon />
              </PrimaryIcon>
            </SC.MiddleBarButton>
            <div ref={this.accountFlyout}>
              <AccountFlyout
                showFlyout={showFlyout}
                showCart={showCart}
                aria-hidden={!showFlyout}
              />
            </div>
          </>}

        {showCart
          && <CartButton />}

        <SC.SecurityIcons showIcons={!showCart && !isMobile}>
          <ExternalComponent
            id={SECURITY_ICONS_ID}
            viaWebC={viaWebC}
            url={securityIconsURL}
          />
        </SC.SecurityIcons>
      </SC.MiddleBarStyled>
    )
  }
}

export default MiddleBar
